/** @readonly Management routes */
export const MANAGEMENT_ROUTES = Object.freeze({
  PROFILE_MANAGEMENT: '/r/management/profile-management',
  PROFILE_LIST: '/r/management/profile-list',
  USER_MANAGEMENT: '/r/management/user-management',
  /** @deprecated Use USER_MANAGEMENT — kept for redirects and bookmarks */
  USER_CREATE: '/r/management/user/create/',
  /** @deprecated Use USER_MANAGEMENT — kept for redirects and bookmarks */
  USER_LIST: '/r/management/user-list/',
  LICENSE: '/r/management/license-management',
  ORGANISATION_LIST: '/r/management/organisation-list',
  ORGANISATION_ONBOARD: '/r/management/organisation-onboard',
  ORGANISATION_ONBOARDING: '/r/management/organisation-onboarding',
  ORGANISATION_MAPPING: '/r/management/organisation-mapping',
  UPDATE_ADDRESS: '/r/management/update-address',
  UPDATE_GST: '/r/management/update-gst',
});
